import React from 'react';
export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<path
			d="M10.125 3.75C7.66406 3.75 5.39844 5.07812 4.14844 7.1875C2.9375 9.33594 2.9375 11.9531 4.14844 14.0625C5.39844 16.2109 7.66406 17.5 10.125 17.5C12.5469 17.5 14.8125 16.2109 16.0625 14.0625C17.2734 11.9531 17.2734 9.33594 16.0625 7.1875C14.8125 5.07812 12.5469 3.75 10.125 3.75ZM10.125 18.75C5.63281 18.75 2 15.1172 2 10.625C2 6.17188 5.63281 2.5 10.125 2.5C14.5781 2.5 18.25 6.17188 18.25 10.625C18.25 12.6562 17.5078 14.4922 16.2969 15.9375L21.8047 21.4453C22.0391 21.6797 22.0391 22.1094 21.8047 22.3438C21.5703 22.5781 21.1406 22.5781 20.9062 22.3438L15.3984 16.7969C13.9922 18.0469 12.1172 18.75 10.125 18.75ZM9.5 14.375V11.25H6.375C6.02344 11.25 5.75 10.9766 5.75 10.625C5.75 10.3125 6.02344 10 6.375 10H9.5V6.875C9.5 6.5625 9.77344 6.25 10.125 6.25C10.4375 6.25 10.75 6.5625 10.75 6.875V10H13.875C14.1875 10 14.5 10.3125 14.5 10.625C14.5 10.9766 14.1875 11.25 13.875 11.25H10.75V14.375C10.75 14.7266 10.4375 15 10.125 15C9.77344 15 9.5 14.7266 9.5 14.375Z"
			fill="currentColor"
		/>
	</svg>
);
